import React, { useMemo } from 'react'

import { DotSeparator, useIsMobile } from '@avantstay/backoffice-core'
import { formatDateRange } from '@avantstay/format-date-range'

import { HotelBookingProps } from '@new/domains/hotelTapeChart/components/HotelOmniSearch/HotelOmniSearch.types'

import { mountRouteUrl, ROUTES } from '@routes'

import * as S from './BookingDetails.styles'

export interface BookingDetailProps {
  booking: HotelBookingProps
}

const getHomeLabel = ({ booking }: BookingDetailProps) => {
  const { hotelRoomType, home, isRoomAssigned } = booking

  const fallbackLabel = `${hotelRoomType?.title ?? home.name}`

  if (isRoomAssigned) {
    return (
      <>
        {fallbackLabel} <DotSeparator /> {home.unitNumber}
      </>
    )
  }

  return fallbackLabel
}

export const BookingDetail = ({ booking }: BookingDetailProps) => {
  const isMobile = useIsMobile()
  const { checkInTiming, checkOutTiming, guestName, hash } = booking
  const homeLabel = useMemo(() => {
    return getHomeLabel({ booking })
  }, [booking])

  if (isMobile) {
    return (
      <S.BookingDetailMobile href={mountRouteUrl(ROUTES.bookingInfo.path, { hash })}>
        <S.BookingDetailColumn>
          <S.DetailTitle>{guestName}</S.DetailTitle>
          <S.DetailSubtitle>
            {formatDateRange(checkInTiming.effectiveTime, checkOutTiming.effectiveTime)}
          </S.DetailSubtitle>
        </S.BookingDetailColumn>
        <S.BookingDetailColumn>
          <S.DetailTitle>{homeLabel}</S.DetailTitle>
        </S.BookingDetailColumn>
      </S.BookingDetailMobile>
    )
  }

  return (
    <S.BookingDetail data-cy={`omnisearch-result-${hash}`}>
      <S.BookingDetailColumn>
        <S.DetailTitle>{guestName}</S.DetailTitle>
        <S.DetailSubtitle>{hash}</S.DetailSubtitle>
      </S.BookingDetailColumn>
      <S.BookingDetailColumn>
        <S.DetailTitle>
          {formatDateRange(checkInTiming.effectiveTime, checkOutTiming.effectiveTime)}
        </S.DetailTitle>
        <S.DetailSubtitle>{homeLabel}</S.DetailSubtitle>
      </S.BookingDetailColumn>
    </S.BookingDetail>
  )
}
